var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSelectionInverse = function SvgIconSelectionInverse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.384 3.152A1.75 1.75 0 0 1 4.5 2.75h15a1.75 1.75 0 0 1 1.75 1.75v15c0 .408-.143.802-.4 1.114a1 1 0 0 1-.235.235 1.75 1.75 0 0 1-1.115.401h-2.25a1 1 0 1 1 0-2h.586L4.75 6.164v.586a1 1 0 0 1-2 0V4.5c0-.41.144-.804.403-1.117a1 1 0 0 1 .23-.23m2.78 1.598L19.25 17.836V4.75z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 9.5a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1M9.5 20.25a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1M4.75 17.25a1 1 0 1 0-2 0v2.25a1.75 1.75 0 0 0 1.75 1.75h2.25a1 1 0 1 0 0-2h-2z"
  }))));
};
export default SvgIconSelectionInverse;